import { Chart } from '@amcharts/amcharts4/charts';

export function getChartReadyPromise(chart: Chart) {
  let readyPromiseResolve: () => void;
  const readyPromise = new Promise<void>(resolve => readyPromiseResolve = resolve);
  chart.events.on('appeared', () => {
    readyPromiseResolve();
  });
  return readyPromise;
}
